// ----------------------------------------------------------------------

export const account = {
  displayName: 'Humanoide.dev',
  email: 'ola@humanoide.co',
  photoURL: '/assets/images/avatars/noAvatar.png',
};
